import styled from 'styled-components'

export const SelectItem = styled.div`
  display: flex;
  align-items: center;
  color: #E9E9EA;
  border-radius: 24px;
  border: 2px solid #454650;
  padding: 5px 12px;
  margin: 6px 6px;
  cursor: pointer;
  background-color: #2B2D39;
  
  div{
    color: #E9E9EA !important;
  }
  
  img, svg{
    margin-right: 4px;
  }
  
  &.active{
    background-color: #E9E9EA;

    div{
      color: #000000 !important;
    }

    img, svg{
      filter: invert(1);
    }
  }
`
